var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOrganisationSvg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.208 3.36a.616.616 0 0 1 .292.523v18.5a.617.617 0 0 1-.617.617h-3.7a.616.616 0 0 1-.616-.617v-1.85h-1.234v1.85a.616.616 0 0 1-.616.617h-11.1A.616.616 0 0 1 3 22.383V15.6a.617.617 0 0 1 .422-.585L10.4 12.69V8.817a.616.616 0 0 1 .34-.552l9.867-4.933a.616.616 0 0 1 .6.027zM10.4 13.99l-6.167 2.054v5.723H10.4v-7.778zm1.233 7.777H14.1v-1.85a.617.617 0 0 1 .617-.617h2.466a.617.617 0 0 1 .617.617v1.85h2.467V4.88l-8.634 4.317v12.569z",
    fill: "#192048"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.467 16.834H6.7v1.233H5.467v-1.233zm2.466 0h1.234v1.233H7.933v-1.233zM5.467 19.3H6.7v1.233H5.467V19.3zm2.466 0h1.234v1.233H7.933V19.3zm4.934-4.933H14.1V15.6h-1.233v-1.233zm2.466 0h1.234V15.6h-1.233v-1.233zm-2.466 2.466H14.1v1.234h-1.233v-1.233zm2.466 0h1.234v1.234h-1.233v-1.233zm2.467-2.466h1.233V15.6H17.8v-1.233zm0 2.466h1.233v1.234H17.8v-1.233zM12.867 11.9H14.1v1.233h-1.233V11.9zm2.466 0h1.234v1.233h-1.233V11.9zm2.467 0h1.233v1.233H17.8V11.9zm-4.933-2.467H14.1v1.234h-1.233V9.433zm2.466 0h1.234v1.234h-1.233V9.433zm2.467 0h1.233v1.234H17.8V9.433zm0-2.466h1.233V8.2H17.8V6.967z",
    fill: "#192048"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrganisationSvg);
export default __webpack_public_path__ + "static/media/organisationSVG.19e261f4175f56d4e9011ed3c786f306.svg";
export { ForwardRef as ReactComponent };